import { useEffect, useRef } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import WhatsAppWidget from "@/components/site/WhatsAppWidget";
import StickyCta from "@/components/site/StickyCta";
import HomePage from "@/pages/HomePage";
import CataloguePage from "@/pages/CataloguePage";
import ProductGroupPage from "@/pages/ProductGroupPage";

const ScrollManager = ({ lenisRef }) => {
  const location = useLocation();
  useEffect(() => {
    if (!location.hash) {
      const t = setTimeout(
        () => lenisRef.current?.scrollTo(0, { immediate: true }),
        80
      );
      return () => clearTimeout(t);
    }
    const scroll = (instant) =>
      lenisRef.current?.scrollTo(location.hash, {
        offset: -76,
        ...(instant ? { immediate: true } : { duration: 0.5 }),
      });
    const timers = [60, 700, 1600].map((ms, i) =>
      setTimeout(() => scroll(i > 0), ms)
    );
    if (document.fonts?.ready) {
      document.fonts.ready.then(() => scroll(true));
    }
    return () => timers.forEach(clearTimeout);
  }, [location.pathname, location.hash, lenisRef]);
  return null;
};

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager lenisRef={lenisRef} />
      <div className="bg-white font-sans text-navy antialiased">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/catalogue" element={<CataloguePage />} />
            <Route path="/products/:slug" element={<ProductGroupPage />} />
          </Routes>
        </main>
        <Footer />
        <WhatsAppWidget />
        <StickyCta />
        <Toaster position="bottom-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
